import React, {Fragment} from 'react';
import {CopySectionMaskEnum} from 'presentation/constants';
import {useHostName} from 'presentation/hooks';
import {translations} from 'presentation/translations-new';
import {useMediaQueries} from 'presentation/pages';
import {Stack, Typography} from '@mui/material';
import {CopySection} from '../CopySection';
import {ContactPhonesType} from './types';

const {phoneCopied} = translations['pt-br'].commons;

const ContactPhones = ({phones, isDetails, copyDataTagId}: ContactPhonesType) => {
	const {isLaptop} = useMediaQueries();
	const {isCCG} = useHostName();
	const directionPhonesDetails = isLaptop ? 'column' : 'row';
	const directionPhones = isDetails ? directionPhonesDetails : 'column';
	return (
		<Fragment>
			{typeof phones === 'string' ? (
				<CopySection
					value={phones}
					highlightedIcons
					mask={isCCG ? CopySectionMaskEnum.PHONE : CopySectionMaskEnum.PHONE_WITHOUT_DDD}
					snackbarMessage={phoneCopied}
					customPadding="8px 16px"
					dataTagId={{copy: copyDataTagId}}
				/>
			) : (
				<Stack
					sx={{
						flexDirection: directionPhones,
						gap: '8px',
						width: '100%',
					}}>
					{phones?.map(phone => (
						<Stack key={phone.phone} gap={1} width={'100%'}>
							<Typography variant="body2">{phone.title}</Typography>
							<CopySection
								value={phone.phone}
								highlightedIcons
								mask={CopySectionMaskEnum.WITHOUT_MASK}
								snackbarMessage={phoneCopied}
								customPadding="8px 16px"
								dataTagId={{copy: copyDataTagId}}
							/>
						</Stack>
					))}
				</Stack>
			)}
		</Fragment>
	);
};

export default ContactPhones;
